import 'regenerator-runtime/runtime'; //Standalone runtime for Regenerator-compiled generator and async functions.
import Bootstrap from './Bootstrap';

export default class Startup {
  constructor() {
    new Bootstrap();
  }
}

new Startup();
